import { useEffect, useState } from 'react';
import { BadgeV3 } from '@cimplico/components';
import { DocumentTextIcon } from '@heroicons/react/24/outline';
import { Note, NoteContextEnum } from '../../../types/note';
import NewNote from './NewNote';
import NoteItem from './NoteItem';
import EmptyStateNew from '../../../components/empty-state/EmptyStateNew';
import { useWorkpaperContext } from '../../../providers/WorkpaperProvider';

type NotesListProps = {
    procedureId?: string;
    notes: Note[];
};

function NotesList({ procedureId, notes }: NotesListProps): JSX.Element {
    const [expandNewNote, setExpandNewNote] = useState(false);
    const { readOnly } = useWorkpaperContext();

    useEffect(() => {
        if (procedureId) {
            setExpandNewNote(false);
        }
    }, [procedureId]);

    return (
        <div className="overflow-auto flex flex-col gap-4 h-full">
            {procedureId && (notes.length > 0 || expandNewNote) && (
                <NewNote
                    context={{ id: procedureId, type: NoteContextEnum.WORKPAPER_PROCEDURE }}
                    expanded={expandNewNote}
                    onAction={(): void => {
                        setExpandNewNote(false);
                    }}
                    onExpand={(): void => setExpandNewNote(true)}
                />
            )}

            {notes.length > 0 &&
                notes
                    .sort((a, b) => (a.updatedAt < b.updatedAt ? 1 : -1))
                    .map((note) => <NoteItem key={note.id} note={note} showContextBadge={procedureId === undefined} />)}

            {notes.length === 0 && !expandNewNote && (
                <div className="mt-16">
                    <EmptyStateNew
                        icon={<DocumentTextIcon />}
                        actionText="New Note"
                        actionButtonType="secondary"
                        titleSize="small"
                        onClick={
                            procedureId
                                ? (): void => {
                                      setExpandNewNote(true);
                                  }
                                : undefined
                        }
                        title="No notes"
                        disableActionButton={readOnly}
                        helpText="Procedure notes will appear here."
                    />
                </div>
            )}
        </div>
    );
}

export default NotesList;
